<template>
  <div>
    <BackBtn :goBefore="false" @click.native="modal=false" />
    <table class="announcement-table">
      <thead>
        <tr>
          <th>{{adStatus ? $t('common.add') : $t('common.modify') }}{{$t('front.bulltin')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="pt-1">
            <Checkbox v-model="isAll" @on-change="allChecked('checkSiteArry')">
              <span>{{$t('common.all')}}</span>
            </Checkbox>
            <CheckboxGroup v-model="checkSiteArry" style="display: inline-block;">
              <Checkbox v-for="(it, i) in siteList" :key="i" :label="it.id">
                <span>{{ it.memname }}</span>
              </Checkbox>
            </CheckboxGroup>
          </td>
        </tr>
        <tr>
          <td>
            <Checkbox v-model="lv8" @on-change="allChecked('checkLvArry')">
              <span>{{$t('common.all')}}</span>
            </Checkbox>
            <CheckboxGroup v-model="checkLvArry" style="display: inline-block;">
              <Checkbox v-for="(it, i) in lvData" :key="i" :label="it.label">
                <span>{{it.name}}</span>
              </Checkbox>
            </CheckboxGroup>
          </td>
        </tr>
        <tr>
          <td class="py-1">
            <div>
              <span class="mx-1">{{$t('navlist.game')}}:</span>
              <Select v-if="gameSelect.length" v-model="nowGame" style="width: 120px;">
                <Option
                  v-for="item in gameSelect"
                  :key="item.gameid"
                  :value="item.gameid"
                >{{ item.gamename }}</Option>
              </Select>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <Input v-model="content" type="textarea" :autosize="{minRows: 5}" />
          </td>
        </tr>
        <tr>
          <td class="pt-1">
            <Checkbox v-model="valid">{{$t('operator.askValid')}}</Checkbox>
            <Checkbox v-model="spbounce">{{$t('front.importantbulltin')}}</Checkbox>
            <Checkbox v-model="anon">{{$t('front.immediatebulltin')}}</Checkbox>
            <Checkbox v-model="bounce">{{$t('front.loginModal')}}</Checkbox>
            <span class="order-input">
              {{$t('front.showOrder')}}：
              <Input v-model="disorder" />
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <Button
              type="success"
              @click="confirm"
            >{{adStatus ? $t('common.add') : $t('common.modify') }}</Button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AnnouncementTable',
  props: {
    showTable: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    adid: Number,
    siteList: Array
  },
  data () {
    return {
      disorder: 1,
      valid: false,
      bounce: false,
      spbounce: false,
      anon: false,
      content: '',
      action: [
        { val: '0', text: this.$t('common.all') }
      ],
      dropText: '',
      nowGame: 0,
      checkSiteArry: [],
      isAll: false,
      lvData: [
        { label: 1, name: this.$t('navlist.operator') },
        { label: 2, name: this.$t('common.level2') },
        { label: 3, name: this.$t('common.level3') },
        { label: 4, name: this.$t('common.level4') },
        { label: 5, name: this.$t('common.level5') },
        { label: 6, name: this.$t('common.level6') },
        { label: 7, name: this.$t('common.level7') }
      ],
      checkLvArry: [],
      lv8: false
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getAllGame']),
    modal: {
      get () {
        return this.showTable
      },
      set (val) {
        this.adStatus = false
        this.$emit('update:showTable', val)
      }
    },
    adStatus: {
      get () {
        return this.isAdd
      },
      set (val) {
        this.$emit('update:isAdd', val)
      }
    },
    gameSelect () {
      if (this.getAllGame && !this.getAllGame.length) return []
      let gameObj = this.getAllGame.filter(item => [1, 14, 15, 78, 210, 212].includes(item.gameid))
      gameObj = [{ gameid: 0, gamename: this.$t('common.all') }, ...gameObj]
      return gameObj;
    }
  },
  watch: {
    checkSiteArry (val) {
      this.isAll = val.length == this.siteList.length
    },
    checkLvArry (val) {
      this.lv8 = val.length == 7 || false
    }
  },
  mounted () {
    if (this.adStatus) this.checkSiteArry = this.siteList.filter(it => it.islinkodds).map(it => it.id)
    if (!this.adStatus) this.getMdData()
  },
  methods: {
    allChecked (key) {
      if (key == 'checkSiteArry') this.checkSiteArry = this.isAll ? this.siteList.map(it => it.id) : []
      else this.checkLvArry = this.lv8 ? this.lvData.map(it => it.label) : []
    },
    lvCheck (val) {
      return this.checkLvArry.some(it => it == val) ? 1 : 0
    },
    async confirm () {
      if (this.disorder < 0 || !/^\d+$/.test(this.disorder)) return this.$Message.error(this.$t('message.indexLessThan0'))
      if (this.content.trim().length < 1) return this.$Message.error(this.$t('message.pleaseInputCont'))
      let apiname = this.adStatus ? 'anad' : 'adupo'
      let obj = {
        loid: this.getmember.pid,
        content: this.content,
        stid_list: this.checkSiteArry.toString(),
        lv1: this.lvCheck(1),
        lv2: this.lvCheck(2),
        lv3: this.lvCheck(3),
        lv4: this.lvCheck(4),
        lv5: this.lvCheck(5),
        lv6: this.lvCheck(6),
        lv7: this.lvCheck(7),
        disorder: this.disorder,
        bounce: this.bounce ? 1 : 0,
        spbounce: this.spbounce ? 1 : 0,
        valid: this.valid ? 1 : 0,
        gameclass: Number(this.nowGame),
        anon: this.anon ? 1 : 0
      }
      if (!this.adStatus) obj.aid = this.adid
      try {
        const res = await this.$axios.setting[apiname](obj)
        if (res.status != 1) return this.$Message.error(this.$t('message.failure'))
        this.$Message.success(this.$t('message.success'))
        this.modal = false
        this.$emit('getAnnounceData')
      } catch (error) {
        console.error(error)
      }
    },
    async getMdData () {
      try {
        const res = await this.$axios.setting.aduge(this.adid)
        if ('status' in res && res.status === 0) return
        let data = res[0]
        this.checkSiteArry = data.stid_list.split(',').map(id => Number(id))
        this.isAll = this.checkSiteArry.length == this.siteList.length
        this.valid = data.valid == 1 ? true : false
        this.bounce = data.bounce == 1 ? true : false
        this.spbounce = data.spbounce == 1 ? true : false
        this.anon = data.anon == 1 ? true : false
        this.content = data.content
        this.disorder = data.disorder
        this.nowGame = data.gameclass
        this.lv1 = data.lv1 == 1 && this.checkLvArry.push(1)
        this.lv2 = data.lv2 == 1 && this.checkLvArry.push(2)
        this.lv3 = data.lv3 == 1 && this.checkLvArry.push(3)
        this.lv4 = data.lv4 == 1 && this.checkLvArry.push(4)
        this.lv5 = data.lv5 == 1 && this.checkLvArry.push(5)
        this.lv6 = data.lv6 == 1 && this.checkLvArry.push(6)
        this.lv7 = data.lv7 == 1 && this.checkLvArry.push(7)
      } catch (error) {
        console.error(error)
        this.modal = false
      }
    }
  }
}
</script>
<style lang="scss">
.announcement-table {
  width: 100%;
  text-align: center;
  .ivu-checkbox-small .ivu-checkbox-checked .ivu-checkbox-inner:after {
    top: 1px;
    left: 3px;
  }
  .ivu-btn:hover.pc1 {
    &:hover {
      border-color: #f00;
    }
  }
  tr {
    th {
      background: #1d3c78;
      color: #fff;
      border-right: 1px solid #7893c7;
      padding: 8px 0;
    }
    td {
      .order-input {
        font-size: 14px;
        .ivu-input-wrapper {
          width: 100px;
          .ivu-input {
            width: 100%;
          }
        }
      }
    }
  }
  .drop-block {
    margin-left: 0.5em;
    margin-right: 0.5em;
    .ivu-dropdown {
      background-color: #fff;
      border: solid 1px #999;
      padding: 0 10px;
      .ivu-dropdown-rel {
        a {
          color: #000;
          text-align: center;
        }
      }
      .ivu-select-dropdown {
        margin-left: -2px;
      }
    }
  }
}
</style>
